export const BP_DESKTOP = 900;
export const VIEWPORT_WIDTH = window.innerWidth;
